import { IconButton, Tooltip } from "@mui/material";
import { Comment, CommentOutlined } from "@mui/icons-material";
import Messages from "../../../localization/Messages";
import { useState } from "react";
import { useIntl } from "react-intl";
import RpisDialog from "../../RpisDialog/RpisDialog";
import ShipRemarkDialog from "./ShipRemarkDialog";
import { useSidebarOwner } from "../../../contexts/SidebarOwnerContext";
import { IShipDispatcher } from "../../../models/shipDispatcher";
import "./EditRemarksDispatcher.css";

export type EditRemarksDispatcherProps = {
    onSubmit?: () => Promise<void>;
    disabled?: boolean;
};

export function EditRemarksDispatcher({
    onSubmit = async () => {},
    disabled = false,
}: EditRemarksDispatcherProps) {
    const [ship] = useSidebarOwner<IShipDispatcher>();
    const remark = ship?.remarks;
    const intl = useIntl();
    const [open, setOpen] = useState(false);
    const buttonTitleSuffix = remark ? `: ${remark}` : "";

    const onOpen = () => {
        if (!disabled) setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Tooltip
                key={remark}
                title={`${intl.formatMessage(Messages.editRemarksDispatcher)}${buttonTitleSuffix}`}
            >
                <IconButton
                    onClick={onOpen}
                    className="remarks-dispatcher-icon"
                    aria-label={intl.formatMessage(Messages.editRemarksDispatcher)}
                    disabled={disabled}
                >
                    {remark ? <Comment /> : <CommentOutlined />}
                </IconButton>
            </Tooltip>
            <RpisDialog
                fullWidth
                size="sm"
                dialogOpen={open}
                title={intl.formatMessage(Messages.editRemarksDispatcher)}
                onClose={onClose}
                content={<ShipRemarkDialog onClose={onClose} onSubmit={onSubmit} field="remarks" />}
            />
        </>
    );
}

export default EditRemarksDispatcher;
